module.exports = __webpack_public_path__ + "assets/8a8527b20e481390ab1f5d3cf17b1b05.mp3";